import Swiper, { Navigation, Pagination, Autoplay, Grid } from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay, Grid]);

$(() => {
    const sliderSwiper = new Swiper('.slider .swiper-container', {
        // Default parameters
        slidesPerView: 1,
        spaceBetween: 0,
        // Responsive breakpoints
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
            // when window width is >= 480px
            480: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
            // when window width is >= 640px
            640: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
        },
        // Enable autoplay
        autoplay: {
            delay: 3000, // Set the time in milliseconds between slide transitions (e.g., 3000ms = 3 seconds)
            disableOnInteraction: true,
        },
        // Enable loop if you want the carousel to start over from the first slide after reaching the last slide
        loop: true,
        //navigation
        navigation: {
            nextEl: '.swiper__buttons-next',
            prevEl: '.swiper__buttons-prev',
        },
    });

    const attendeesSwiper = new Swiper('.attendees .swiper', {
        slidesPerView: 1,
        spaceBetween: 0,
        breakpoints: {
            320: {
                slidesPerView: 3,
                spaceBetween: 30,
                grid: {
                    rows: 4,
                    fill: 'row',
                },
            },
            576: {
                slidesPerView: 4,
                spaceBetween: 30,
                grid: {
                    rows: 4,
                    fill: 'row',
                },
            },
            992: {
                slidesPerView: 8,
                spaceBetween: 58,
                grid: {
                    rows: 4,
                    fill: 'row',
                },
            },
        },
        navigation: {
            nextEl: '.swiper-buttons-next',
            prevEl: '.swiper-buttons-prev',
        },
    });

    const swiperLogoContainer = document.querySelector('.logo-slider__carousel .swiper');
    const swiperLogoSlides = swiperLogoContainer.querySelectorAll('.swiper-slide');

    // Check if the number of slides is less than slidesPerView
    const requiredSlides = 12; // Set this to the maximum slidesPerView across breakpoints
    if (swiperLogoSlides.length < requiredSlides) {
      // Duplicate the slides until there are enough to fill slidesPerView
      const slidesToDuplicate = Array.from(swiperLogoSlides);
      while (swiperLogoContainer.querySelectorAll('.swiper-slide').length < requiredSlides) {
        slidesToDuplicate.forEach(slide => {
          swiperLogoContainer.querySelector('.swiper-wrapper').appendChild(slide.cloneNode(true));
        });
      }
    }

    const swiperLogo = new Swiper(swiperLogoContainer, {
      slidesPerView: 6,
      spaceBetween: 16,
      loop: true,
      autoplay: {
        delay: 1,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      },
      speed: 2000,
      breakpoints: {
        1200: {
          slidesPerView: 10,
          spaceBetween: 20,
        },
        1373: {
          slidesPerView: 12,
          spaceBetween: 20,
        },
      },
    });
});

